// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ouq7ip {
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.b65U8C {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  margin-top: var(--spacing-3);
}

.LB54Xf {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  margin: 0;
}

.KhLYqL {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--spacing-3);
  width: 100%;
  margin-top: var(--spacing-3);
}

.AVaeId {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2);
  width: 100%;
  min-height: 144px;
  padding: var(--spacing-3);
  background: var(--surface-neutral-white);
  border: 1px solid var(--stroke-neutral-silver);
  border-radius: var(--radius-m);
  cursor: pointer;
  font-family: var(--font-family-base);
  text-align: center;
  transition: var(--transition-color);
  box-sizing: border-box;
}

.AVaeId:focus-within {
  outline: 2px solid var(--stroke-primary-medium);
  outline-offset: 2px;
}

.eNnvl3 {
  background: var(--surface-primary-subtle);
}

.ozlg8E {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: var(--spacing-2);
}

.jyPE3f {
  display: inline-flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  gap: var(--spacing-1);
}

.wZKfx1 {
  width: 20px !important;
  height: 20px !important;
  flex-shrink: 0;
}

.nFBYGT {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  object-fit: contain;
}

.nFBYGT svg {
  width: 100%;
  height: 100%;
}

.LTDsSf {
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  line-height: 1;
  color: var(--text-primary-medium);
  margin: 0;
}

.zcJSP3 {
  width: 100%;
  max-width: 290px;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: normal;
  color: var(--text-neutral-dark);
  text-align: center;
  margin: 0;
}

.Gp37pX {
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  color: var(--link-default);
  text-decoration: underline;
  cursor: pointer;
}

.Gp37pX:hover {
  color: var(--link-hover);
}

.Gp37pX:focus-visible {
  outline: 2px solid var(--stroke-primary-medium);
  outline-offset: 2px;
}

.YcIYQp {
  position: absolute;
  top: var(--spacing-1-5);
  right: var(--spacing-1-5);
  padding: 0 var(--spacing-0-5);
  border-radius: var(--radius-s);
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  line-height: 22px;
  background: transparent;
  border: 1px solid var(--stroke-neutral-subtle);
  color: var(--text-neutral-dark);
}

.hTpIo7 {
  background: var(--success-green-light);
  border-color: var(--status-success);
}

.wMglVN {
  background: transparent;
  border-color: var(--status-info);
}

.sd8sGT {
  position: absolute;
  top: var(--spacing-1-5);
  left: var(--spacing-1-5);
  width: 24px;
  height: 24px;
  background: transparent;
  border: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.sd8sGT::before {
  content: '';
  width: 16px;
  height: 16px;
  border-radius: var(--radius-pill);
  border: 1px solid var(--stroke-neutral-dark);
  background: var(--surface-neutral-white);
  box-sizing: border-box;
}

.dWpUqg::before {
  border-color: var(--stroke-primary-medium);
  background: radial-gradient(
    circle,
    var(--surface-neutral-white) 0,
    var(--surface-neutral-white) 3px,
    var(--surface-primary-medium) 3px
  );
}

.U5ICXg {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-4);
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  color: var(--text-neutral-stronger);
}

.PxE8iv.PxE8iv {
  margin-top: var(--spacing-1);
  background: transparent;
  border-radius: 0;
  box-shadow: none;
}

.PxE8iv.PxE8iv > div:first-child {
  box-shadow: none;
  padding: 0 0 var(--spacing-1);
  height: auto;
}

.PxE8iv.PxE8iv > div:first-child > div:first-child {
  gap: var(--spacing-3);
}

.PxE8iv.PxE8iv > div:first-child > div:first-child > button {
  padding: var(--spacing-1);
}

.PQKpdZ {
  display: flex;
  justify-content: center;
  gap: var(--spacing-1);
  margin-top: var(--spacing-3);
}

.HbhgBW {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: var(--spacing-1-5);
  border: 1px solid var(--stroke-neutral-silver);
  border-radius: var(--radius-s);
  background: var(--surface-neutral-white);
  cursor: pointer;
  box-sizing: border-box;
}

.HbhgBW:disabled {
  cursor: not-allowed;
}

.AwUvx1 {
  border-color: var(--stroke-primary-medium);
}

.Ea_B2g {
  width: 16px !important;
  height: 16px !important;
  flex-shrink: 0;
}

.pNdFyF {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  overflow: hidden;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/NewRechargePage/components/Products/Products.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,qBAAqB;EACrB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,wCAAwC;EACxC,8CAA8C;EAC9C,8BAA8B;EAC9B,eAAe;EACf,oCAAoC;EACpC,kBAAkB;EAClB,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,cAAc;EACd,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;EAC7B,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,iBAAiB;EACjB,uBAAuB;EACvB,8CAA8C;EAC9C,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,4CAA4C;EAC5C,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C;;;;;GAKC;AACH;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,8CAA8C;EAC9C,8BAA8B;EAC9B,wCAAwC;EACxC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".wizardCardShell {\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  margin-top: var(--spacing-3);\n}\n\n.helper {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: var(--spacing-3);\n  width: 100%;\n  margin-top: var(--spacing-3);\n}\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-2);\n  width: 100%;\n  min-height: 144px;\n  padding: var(--spacing-3);\n  background: var(--surface-neutral-white);\n  border: 1px solid var(--stroke-neutral-silver);\n  border-radius: var(--radius-m);\n  cursor: pointer;\n  font-family: var(--font-family-base);\n  text-align: center;\n  transition: var(--transition-color);\n  box-sizing: border-box;\n}\n\n.card:focus-within {\n  outline: 2px solid var(--stroke-primary-medium);\n  outline-offset: 2px;\n}\n\n.cardSelected {\n  background: var(--surface-primary-subtle);\n}\n\n.cardBody {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  gap: var(--spacing-2);\n}\n\n.cardHeader {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: center;\n  gap: var(--spacing-1);\n}\n\n.icon {\n  width: 20px !important;\n  height: 20px !important;\n  flex-shrink: 0;\n}\n\n.iconRemote {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  object-fit: contain;\n}\n\n.iconRemote svg {\n  width: 100%;\n  height: 100%;\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  line-height: 1;\n  color: var(--text-primary-medium);\n  margin: 0;\n}\n\n.description {\n  width: 100%;\n  max-width: 290px;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: normal;\n  color: var(--text-neutral-dark);\n  text-align: center;\n  margin: 0;\n}\n\n.patInfoLink {\n  padding: 0;\n  border: 0;\n  background: none;\n  font: inherit;\n  color: var(--link-default);\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.patInfoLink:hover {\n  color: var(--link-hover);\n}\n\n.patInfoLink:focus-visible {\n  outline: 2px solid var(--stroke-primary-medium);\n  outline-offset: 2px;\n}\n\n.badge {\n  position: absolute;\n  top: var(--spacing-1-5);\n  right: var(--spacing-1-5);\n  padding: 0 var(--spacing-0-5);\n  border-radius: var(--radius-s);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  line-height: 22px;\n  background: transparent;\n  border: 1px solid var(--stroke-neutral-subtle);\n  color: var(--text-neutral-dark);\n}\n\n.badgePat {\n  background: var(--success-green-light);\n  border-color: var(--status-success);\n}\n\n.badgeAuxilio {\n  background: transparent;\n  border-color: var(--status-info);\n}\n\n.radioCircle {\n  position: absolute;\n  top: var(--spacing-1-5);\n  left: var(--spacing-1-5);\n  width: 24px;\n  height: 24px;\n  background: transparent;\n  border: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.radioCircle::before {\n  content: '';\n  width: 16px;\n  height: 16px;\n  border-radius: var(--radius-pill);\n  border: 1px solid var(--stroke-neutral-dark);\n  background: var(--surface-neutral-white);\n  box-sizing: border-box;\n}\n\n.radioCircleSelected::before {\n  border-color: var(--stroke-primary-medium);\n  background: radial-gradient(\n    circle,\n    var(--surface-neutral-white) 0,\n    var(--surface-neutral-white) 3px,\n    var(--surface-primary-medium) 3px\n  );\n}\n\n.emptyState {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-4);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-stronger);\n}\n\n.tab.tab {\n  margin-top: var(--spacing-1);\n  background: transparent;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.tab.tab > :global(div):first-child {\n  box-shadow: none;\n  padding: 0 0 var(--spacing-1);\n  height: auto;\n}\n\n.tab.tab > :global(div):first-child > :global(div):first-child {\n  gap: var(--spacing-3);\n}\n\n.tab.tab > :global(div):first-child > :global(div):first-child > :global(button) {\n  padding: var(--spacing-1);\n}\n\n.paginationRow {\n  display: flex;\n  justify-content: center;\n  gap: var(--spacing-1);\n  margin-top: var(--spacing-3);\n}\n\n.paginationButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  padding: var(--spacing-1-5);\n  border: 1px solid var(--stroke-neutral-silver);\n  border-radius: var(--radius-s);\n  background: var(--surface-neutral-white);\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.paginationButton:disabled {\n  cursor: not-allowed;\n}\n\n.paginationButtonActive {\n  border-color: var(--stroke-primary-medium);\n}\n\n.paginationIcon {\n  width: 16px !important;\n  height: 16px !important;\n  flex-shrink: 0;\n}\n\n.visuallyHiddenInput {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  overflow: hidden;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wizardCardShell": `Ouq7ip`,
	"content": `b65U8C`,
	"helper": `LB54Xf`,
	"grid": `KhLYqL`,
	"card": `AVaeId`,
	"cardSelected": `eNnvl3`,
	"cardBody": `ozlg8E`,
	"cardHeader": `jyPE3f`,
	"icon": `wZKfx1`,
	"iconRemote": `nFBYGT`,
	"title": `LTDsSf`,
	"description": `zcJSP3`,
	"patInfoLink": `Gp37pX`,
	"badge": `YcIYQp`,
	"badgePat": `hTpIo7`,
	"badgeAuxilio": `wMglVN`,
	"radioCircle": `sd8sGT`,
	"radioCircleSelected": `dWpUqg`,
	"emptyState": `U5ICXg`,
	"tab": `PxE8iv`,
	"paginationRow": `PQKpdZ`,
	"paginationButton": `HbhgBW`,
	"paginationButtonActive": `AwUvx1`,
	"paginationIcon": `Ea_B2g`,
	"visuallyHiddenInput": `pNdFyF`
};
module.exports = ___CSS_LOADER_EXPORT___;
